"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _core = require("@material-ui/core");

var _excluded = ["icon", "disabled", "divider", "children"];

/**
 * This is done to appease styleguidist. Note that
 * the props are not more specific because internally
 * Material-UI needs access to a ref
 */
var MenuItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      divider = _ref.divider,
      children = _ref.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, (0, _extends2["default"])({}, otherProps, {
    disabled: disabled,
    divider: divider
  }), /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: Boolean(icon),
    alternate: children
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, icon), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    inset: true
  }, children)));
});

MenuItem.propTypes = {
  /** Icon displayed to the left of the content. */
  icon: _propTypes["default"].element,

  /** If `true`, the item will be disabled. */
  disabled: _propTypes["default"].bool,

  /** If `true`, the item will have a divider underneath. */
  divider: _propTypes["default"].bool,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the component is clicked.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onClick: _propTypes["default"].func
};
MenuItem.defaultProps = {
  disabled: false,
  divider: false
};
var _default = MenuItem;
exports["default"] = _default;